// extracted by mini-css-extract-plugin
export default {"overlay":"uz-z","bodyOpen":"vz-z","content":"wz-z","header":"xz-z","close":"yz-z","closeNoHeading":"zz-z"};